import React from 'react';
import type { IconProps } from '@models/types';
import { styled } from '@mui/material/styles';

const Icon: React.FC<IconProps> = (props) => (
    <svg
        width='24'
        height='24'
        viewBox='0 0 24 24'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
        {...props}
    >
        <path
            d='M13.3195 17.8806C13.3195 20.8629 10.9021 23.2808 7.91972 23.2808C4.93699 23.2808 2.51953 20.8629 2.51953 17.8806C2.51953 14.8982 4.93699 12.4804 7.91972 12.4804C10.9021 12.4804 13.3195 14.8982 13.3195 17.8806Z'
            fill='#FF6600'
        />
        <path
            d='M24.0002 10.32C24.0002 13.302 21.5827 15.7202 18.6004 15.7202C15.6177 15.7202 13.2002 13.302 13.2002 10.32C13.2002 7.3377 15.6177 4.91945 18.6004 4.91945C21.5827 4.91945 24.0002 7.3377 24.0002 10.32Z'
            fill='#FFCC00'
        />
        <path
            d='M10.8 10.2004C10.8 13.1823 8.38252 15.6006 5.39979 15.6006C2.41785 15.6006 0 13.1823 0 10.2004C0 7.21807 2.41785 4.79982 5.39979 4.79982C8.38252 4.79982 10.8 7.21807 10.8 10.2004Z'
            fill='#0089CC'
        />
        <path
            d='M21.6002 17.8806C21.6002 20.8629 19.1827 23.2808 16.1996 23.2808C13.2177 23.2808 10.7998 20.8629 10.7998 17.8806C10.7998 14.8982 13.2177 12.4804 16.1996 12.4804C19.1827 12.4804 21.6002 14.8982 21.6002 17.8806Z'
            fill='#009939'
        />
        <path
            d='M17.4 5.40011C17.4 8.38244 14.9821 10.8003 11.9998 10.8003C9.01746 10.8003 6.59961 8.38244 6.59961 5.40011C6.59961 2.41777 9.01746 -7.72476e-05 11.9998 -7.72476e-05C14.9821 -7.72476e-05 17.4 2.41777 17.4 5.40011Z'
            fill='#BF0000'
        />
        <path
            d='M13.2002 10.3199C13.2002 10.4335 13.2101 10.5447 13.2172 10.6567C15.6125 10.1041 17.4002 7.96258 17.4002 5.39945C17.4002 5.28585 17.3903 5.17422 17.3831 5.06219C14.9879 5.61519 13.2002 7.75674 13.2002 10.3199Z'
            fill='#FC0007'
        />
        <path
            d='M13.9131 12.994C14.8437 14.6209 16.5926 15.7202 18.6011 15.7202C19.4198 15.7202 20.1928 15.5326 20.8884 15.2064C19.9581 13.5795 18.2092 12.4802 16.2003 12.4802C15.3817 12.4802 14.6086 12.6678 13.9131 12.994Z'
            fill='#1CD306'
        />
        <path
            d='M10.7998 17.8802C10.7998 19.1996 11.274 20.407 12.0602 21.3447C12.8456 20.407 13.3198 19.1996 13.3198 17.8802C13.3198 16.5609 12.8456 15.3535 12.0602 14.4158C11.274 15.3535 10.7998 16.5609 10.7998 17.8802Z'
            fill='#0F7504'
        />
        <path
            d='M3.26172 15.1584C3.91764 15.4419 4.63967 15.6006 5.3997 15.6006C7.38845 15.6006 9.12109 14.5227 10.0585 12.9223C9.40254 12.6388 8.68011 12.4805 7.92048 12.4805C5.93173 12.4805 4.1987 13.5584 3.26172 15.1584Z'
            fill='#0C5E87'
        />
        <path
            d='M6.62296 4.94395C6.6103 5.09437 6.59961 5.24559 6.59961 5.39957C6.59961 7.96072 8.3845 10.1003 10.777 10.6553C10.7893 10.5049 10.8 10.3536 10.8 10.2C10.8 7.6389 9.01548 5.49854 6.62296 4.94395Z'
            fill='#6B0001'
        />
        <path
            d='M7.12763 17.2116H6.28289C5.53711 17.2116 4.93066 16.6071 4.93066 15.8633V8.21705C4.93066 7.47325 5.53711 6.86839 6.28289 6.86839H16.8754C17.6212 6.86839 18.2273 7.47325 18.2273 8.21705V15.8633C18.2273 16.6071 17.6212 17.2116 16.8754 17.2116H13.2669L6.02677 20.7607L7.12763 17.2116Z'
            fill='white'
        />
    </svg>
);

export const LiveKitIcon = styled(Icon)({});
